<label class="container-simple-toggle" [ngClass]="{ 'inverted-label': invertLabel }">
  <input
    id="structured-search-toggle"
    class="js-structured-search-toggle"
    type="checkbox"
    style="display: none"
    (change)="handlerClick($event)"
    [checked]="checked"
  />

  <div class="simple-toggle">
    <span class="ball"></span>
  </div>

  <span *ngIf="label" class="label">
    <label for="structured-search-toggle">{{ label | cxTranslate }}</label>
  </span>
</label>
